import DOMPurify from "dompurify";

export const VENUE_POLICY_ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "s",
  "strike",
  "del",
  "ul",
  "ol",
  "li",
];

const EMPTY_HTML = /^(<p>(<br\s*\/?>|\s|&nbsp;)*<\/p>|\s|&nbsp;)*$/i;

export const sanitizeVenuePolicyHtml = (html) => {
  const raw = String(html ?? "");
  if (!raw.trim()) return "";

  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: VENUE_POLICY_ALLOWED_TAGS,
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });
};

export const isVenuePolicyEmpty = (html) => {
  const sanitized = sanitizeVenuePolicyHtml(html);
  if (!sanitized) return true;
  if (EMPTY_HTML.test(sanitized.trim())) return true;

  const text = sanitized
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();

  return !text;
};

export const normalizeVenuePolicyHtml = (html) => {
  const sanitized = sanitizeVenuePolicyHtml(html);
  return isVenuePolicyEmpty(sanitized) ? "" : sanitized;
};

export const resolveEventPolicyHtml = (event) => {
  const snapshot = normalizeVenuePolicyHtml(event?.venue_policy_snapshot);
  if (snapshot) return snapshot;
  return normalizeVenuePolicyHtml(event?.description);
};

export const venuePolicyToPlainText = (html) => {
  const sanitized = sanitizeVenuePolicyHtml(html);
  if (isVenuePolicyEmpty(sanitized)) return "";

  return sanitized
    .replace(/<\/(p|li|div|h[1-6])>/gi, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<li>/gi, "• ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};
